(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/active-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/active-member.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  InfoPairAmount = _svs$arena$pages$team.InfoPairAmount,
  MemberPopover = _svs$arena$pages$team.MemberPopover,
  MemberPopoverItem = _svs$arena$pages$team.MemberPopoverItem;
const _svs$arena$pages$team2 = svs.arena.pages.teams.teamMembers,
  MemberSendEmail = _svs$arena$pages$team2.MemberSendEmail,
  MemberName = _svs$arena$pages$team2.MemberName;
const Button = svs.ui.ReactButton;
const memberRoles = svs.arena.constants.memberRoles;
const _svs$arena$store$team = svs.arena.store.teams.actions,
  changeMemberActivity = _svs$arena$store$team.changeMemberActivity,
  setTeamBalance = _svs$arena$store$team.setTeamBalance,
  changeMemberRole = _svs$arena$store$team.changeMemberRole;
const _svs$arena$service$te = svs.arena.service.teamsService,
  postDeactivateMemberAsync = _svs$arena$service$te.postDeactivateMemberAsync,
  putAdminMemberAsync = _svs$arena$service$te.putAdminMemberAsync;
const useRemoveMember = svs.arena.shared.hooks.useRemoveMember;
const _svs$arena$pages$team3 = svs.arena.pages.teams.dialogs,
  showDeactivateMemberSuccess = _svs$arena$pages$team3.showDeactivateMemberSuccess,
  showTechnicalError = _svs$arena$pages$team3.showTechnicalError,
  showConfirmDeactivateDialog = _svs$arena$pages$team3.showConfirmDeactivateDialog,
  showAddedAdminSuccess = _svs$arena$pages$team3.showAddedAdminSuccess,
  showRemovedAdminSucess = _svs$arena$pages$team3.showRemovedAdminSucess;
const ActiveMember = _ref => {
  let member = _ref.member,
    teamId = _ref.teamId,
    isLeader = _ref.isLeader,
    teamName = _ref.teamName;
  const customerId = member.customerId,
    firstName = member.firstName,
    lastName = member.lastName,
    memberBalance = member.memberBalance;
  const dispatch = ReactRedux.useDispatch();
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isShowEmail = _React$useState2[0],
    setIsShowEmail = _React$useState2[1];
  const hasBalance = parseInt(memberBalance, 10) > 0;
  const isInactive = false;
  const _useRemoveMember = useRemoveMember(teamId, teamName, customerId, firstName, lastName, hasBalance && memberBalance, isInactive),
    onRemoveMember = _useRemoveMember.onRemoveMember;
  const setMemberInactive = async () => {
    const dialogResponse = await showConfirmDeactivateDialog(firstName, member.memberBalance);
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members',
      opt_label: dialogResponse ? 'rest' : 'rest_cancel'
    };
    svs.components.analytics.trackEvent(track);
    if (!dialogResponse) {
      return;
    }
    const dispatchDeactiveActions = () => {
      dispatch(changeMemberActivity({
        teamId,
        customerId,
        active: false
      }));
      if ((member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN) {
        dispatch(changeMemberRole({
          teamId,
          customerId,
          memberRole: memberRoles.NORMAL
        }));
      }
    };
    const responseDeactivate = await postDeactivateMemberAsync(customerId, teamId);
    if (responseDeactivate.error) {
      if (responseDeactivate.code === '22 108') {
        dispatchDeactiveActions();
        return;
      }
      showTechnicalError();
    } else {
      const _responseDeactivate$d = responseDeactivate.data.syndicateAmounts,
        syndicateBalance = _responseDeactivate$d.syndicateBalance,
        playableAmount = _responseDeactivate$d.playableAmount;
      dispatchDeactiveActions();
      dispatch(setTeamBalance({
        teamId,
        syndicateBalance,
        playableAmount,
        customerId
      }));
      showDeactivateMemberSuccess(firstName, lastName);
    }
  };
  const showEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowEmail(true);
  };
  const trackMemberAdmin = madeAdmin => ({
    category: 'spela-tillsammans',
    action: 'action_members',
    opt_label: madeAdmin ? 'add_member_place_bet' : 'remove_member_place_bet'
  });
  const addMemberAdmin = async () => {
    const response = await putAdminMemberAsync(customerId, teamId, true);
    if (response.error) {
      showTechnicalError();
    } else {
      svs.components.analytics.trackEvent(trackMemberAdmin(true));
      dispatch(changeMemberRole({
        teamId,
        customerId,
        memberRole: memberRoles.ADMIN
      }));
      showAddedAdminSuccess("".concat(member.firstName, " ").concat(member.lastName));
    }
  };
  const RemoveMemberAdmin = async () => {
    const response = await putAdminMemberAsync(customerId, teamId, false);
    if (response.error) {
      showTechnicalError();
    } else {
      svs.components.analytics.trackEvent(trackMemberAdmin(false));
      dispatch(changeMemberRole({
        teamId,
        customerId,
        memberRole: memberRoles.NORMAL
      }));
      showRemovedAdminSucess("".concat(member.firstName, " ").concat(member.lastName));
    }
  };
  return React.createElement("div", {
    className: "bg-tur-100 padding-1 u-border-radius-4 margin-v"
  }, React.createElement("div", {
    className: "u-flex f-400 line-height-1"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(MemberName, {
    firstName: member.firstName,
    lastName: member.lastName
  })), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.TEAM_LEADER && React.createElement("div", null, "Lagledare"), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN && React.createElement("div", null, "Spell\xE4ggare"), React.createElement(InfoPairAmount, {
    amount: member.memberBalance,
    isColor: !hasBalance,
    title: "Saldo i laget"
  })), !member.isCurrentMember && React.createElement("div", {
    className: "u-flex u-flex-align-items-center"
  }, isLeader && React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: showEmail
  }, " Skicka e-post "), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN && React.createElement(MemberPopoverItem, {
    onClick: RemoveMemberAdmin
  }, " Ta bort spell\xE4ggare "), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.NORMAL && React.createElement(MemberPopoverItem, {
    onClick: addMemberAdmin
  }, " G\xF6r till spell\xE4ggare "), React.createElement(MemberPopoverItem, {
    onClick: setMemberInactive
  }, " S\xE4tt vilande "), React.createElement(MemberPopoverItem, {
    onClick: onRemoveMember
  }, " Ta bort ")), !isLeader && React.createElement(Button, {
    onClick: () => setIsShowEmail(true),
    size: 100,
    transparent: true
  }, "Skicka e-post"))), isShowEmail && React.createElement(MemberSendEmail, {
    customerId: member.customerId,
    firstName: member.firstName,
    lastName: member.lastName,
    onHide: () => setIsShowEmail(false),
    teamId: teamId
  }));
};
svs.arena.pages.teams.teamMembers.ActiveMember = ActiveMember;

 })(window);